function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { CoreVideoInternal } from '../../../../core-video-internal';
import { sdkLogger } from '../../../../logger';
import { JsonUtils } from '../../../../utils/json-utils';
import { PixelFetch } from '../../../adverts/pixel-fetch';
import { NielsenContentType } from './nielsen-api.enums';
export { NielsenContentType, NielsenEventType, NielsenIsFullEpisode } from './nielsen-api.enums';
// See docs: https://engineeringportal.nielsen.com/docs/DCR_Video_%26_Static_Cloud_API#Configure_Payload
// TODO
// event name
// position in seconds
// unix timestamp in milliseconds
export var Endpoint = {
    testing: 'https://sandbox2-cloudapi.imrworldwide.com/nmapi/v2/',
    production: 'https://cloudapi.imrworldwide.com/nmapi/v2/'
};
var Logger = sdkLogger.withContext('NielsenCloudApiClient');
// Docs: https://engineeringportal.nielsen.com/docs/DCR_Video_%26_Static_Cloud_API#Request_Overview
export var NielsenCloudApiClient = /*#__PURE__*/ function() {
    "use strict";
    function NielsenCloudApiClient(config, nielsenContentData, reportingData, metaAdapter) {
        var pixelFetch = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : new PixelFetch(self);
        _class_call_check(this, NielsenCloudApiClient);
        _define_property(this, "config", void 0);
        _define_property(this, "nielsenContentData", void 0);
        _define_property(this, "reportingData", void 0);
        _define_property(this, "metaAdapter", void 0);
        _define_property(this, "pixelFetch", void 0);
        _define_property(this, "host", void 0);
        _define_property(this, "devInfo", void 0);
        this.config = config;
        this.nielsenContentData = nielsenContentData;
        this.reportingData = reportingData;
        this.metaAdapter = metaAdapter;
        this.pixelFetch = pixelFetch;
        this.host = config.enableProduction ? Endpoint.production : Endpoint.testing;
        this.devInfo = Object.freeze({
            devId: config.devId,
            apn: config.appName,
            apv: config.appVersion,
            uoo: 'false'
        });
    }
    _create_class(NielsenCloudApiClient, [
        {
            key: "destroy",
            value: function destroy() {
                this.pixelFetch = null;
            }
        },
        {
            key: "trackAdvert",
            value: function trackAdvert(ad, adBreak, position) {
                var payload = this.metaAdapter.createAdEvent(this.devInfo, ad, adBreak, position);
                this.logEvent(NielsenContentType.Ad, payload);
                this.sendTrackingRequest(payload);
            }
        },
        {
            key: "trackContent",
            value: function trackContent(type, position) {
                var assetMetadata = this.reportingData.assetMetadata;
                var _this_nielsenContentData = this.nielsenContentData, playoutData = _this_nielsenContentData.playoutData, checkContentHasAds = _this_nielsenContentData.checkContentHasAds;
                var payload = this.metaAdapter.createContentEvent(this.devInfo, type, assetMetadata, playoutData, checkContentHasAds(), position, CoreVideoInternal.deviceType);
                this.logEvent(NielsenContentType.Content, payload);
                this.sendTrackingRequest(payload);
            }
        },
        {
            key: "sendTrackingRequest",
            value: function sendTrackingRequest(payload) {
                var cloudAppId = this.config.cloudAppId;
                var configAppId = cloudAppId !== null && cloudAppId !== void 0 ? cloudAppId : this.metaAdapter.getNielsenAppId(CoreVideoInternal.deviceType, CoreVideoInternal.deviceInfo.deviceModel);
                var url = new URL("".concat(this.host).concat(configAppId, "/").concat(this.config.sessionId, "/a"));
                url.searchParams.set('b', JsonUtils.stringify(payload));
                this.pixelFetch.fetch(url.toString());
            }
        },
        {
            key: "logEvent",
            value: function logEvent(contentType, payload) {
                Logger.verbose("NielsenCloudApiClient sending ".concat(contentType, " content event for sessionId: ").concat(this.config.sessionId, ":"));
                Logger.verbose(JsonUtils.stringify(payload));
            }
        }
    ], [
        {
            key: "canUse",
            value: function canUse(deviceType, metaAdapter) {
                var isSupported = metaAdapter.isDeviceSupported(deviceType);
                if (isSupported) {
                    Logger.info("NielsenCloudApiClient can support ".concat(deviceType));
                }
                return isSupported;
            }
        }
    ]);
    return NielsenCloudApiClient;
}();

//# sourceMappingURL=nielsen-cloud-api-client.js.map